import { render, staticRenderFns } from "./BitcoinTab.vue?vue&type=template&id=4f2a3a8c&scoped=true"
import script from "./BitcoinTab.vue?vue&type=script&lang=js"
export * from "./BitcoinTab.vue?vue&type=script&lang=js"
import style0 from "./BitcoinTab.vue?vue&type=style&index=0&id=4f2a3a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a3a8c",
  null
  
)

export default component.exports